import { createBrowserRouter } from "react-router-dom";
import App from '../App'
import Home from "./Home";
import AdminPanel from '../pages/AdminPanel'
import AboutPage from "../components/AboutPage";
import MeetFaculty from "../components/MeetFaculty";
import Form from '../components/Form'
import Events from '../components/Events/Events'
import EventsScreen from '../components/EventScreen'
import Admissions from '../components/Admissions'
import Courses from "../components/Courses";
import CourseDetail from '../components/CourseDetail'
import AllEvents from "../pages/AllEvents";
import Dashboard from "../pages/Dashboard";
import ContactReport from "../pages/ContactReport";
import Welcome from "../components/Welcome";
import RouteMap from "../components/RouteMap";
import CulturalActivities from "../components/CulturalActivities";
import ImageGrid from "../components/Gallery";
import Certificate from "../components/Certificate";
import ExamCell from "../components/Examcell";
import AdmissionReport from '../pages/AdmissionReport'
import NewsPanel from "../pages/NewsPanel";
import AdminLogin from "../pages/AdminLogin";
import CustomDialog from "../components/CustomDialog";
import ContactForm from "../components/ContactForm";
import MainPage from "../components/MainPage";
import CertificateApprovals from "../components/CertificateApprovals";
import NewsDetails from "../components/NewsDetails";
import OnlineGrievance from "../pages/OnlineGrievance";
import AntiRaggingCommittee from "../pages/AntiRaggingCommittee";
import InternalComplaint from "../pages/InternalComplaint";
import Communityscst from "../pages/Communityscst";
import BoardofGovernors from "../pages/BoardofGovernors";
import InstitutionIndustryCell from "../pages/InstitutionIndustryCell";
import FoodSafety from "../pages/FoodSafety";
import AicteApprovals from "../pages/AicteApprovals";
const router =createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
        { path: "/", element: <Home/> },
        { path: "/admin-login", element: <AdminLogin /> },
        { path: "/admin-panel", element: <AdminPanel />,
            children: [
                { path: "dashboard", element: <Dashboard /> },
                { path: "all-events", element: <AllEvents /> },
                { path: "contact-report", element: <ContactReport /> },
                { path: "admission-report", element: <AdmissionReport /> },
                { path: "newspanel", element: <NewsPanel /> }
               
            ]
        },
      
        { path: "/about", element: <AboutPage /> },
            { path: "/MeetFaculty", element: <MeetFaculty /> },
            { path:"/form", element:<ContactForm/>},
            { path: "/Admissions", element: <Admissions /> },
            { path: "/EventS", element: <Events /> },
            { path: "/events-screen", element: <EventsScreen /> },
            { path: "/courses", element: <Courses /> },
            { path: "/course-details/:id", element: <CourseDetail /> },
            { path: "/Welcome", element: <Welcome /> },
            { path: "/Gallery", element: <ImageGrid /> },
            { path: "/Certificate", element: <CertificateApprovals /> },
            { path: "/approvals", element: <Certificate/>},
            { path: "/Examcell", element: <ExamCell /> },
            { path: "/CulturalActivities", element: <CulturalActivities /> },
            { path: "/CustomDialog", element: <CustomDialog /> },
            { path: "/RouteMap", element: <RouteMap /> },
            { path: "/newsdetails", element: <NewsDetails/> },
            // { path: "/mainPage", element: <MainPage /> },
            { path: "/facilities/online-grievance", element: <OnlineGrievance/>},   
            {path: "/facilities/anti-ragging", element: <AntiRaggingCommittee/>},
            { path: "/facilities/internal-complaint", element: <InternalComplaint/>},
            { path: "/facilities/community-sc-st", element: <Communityscst/>},
            {path: "/facilities/food-safety", element: <FoodSafety />},
            {path: "/facilities/board-of-governors", element: <BoardofGovernors/>},
            {path: "/facilities/institution-industry-cell", element: <InstitutionIndustryCell/>},
{path: "/facilities/aicte-approval", element: <AicteApprovals/>}
            

            
    ]
}]);
export default router;

